import { FoodOrderingFeatureFlagId, HealthcareSchedulingFeatureFlagId } from "../featureFlagIds";

const UNIVERSAL_METRICS_TO_EXCLUDE: [string, string][] = [
    ["TotalEngagementCount", "Total Engagement Count"],
    ["NoInteraction", "No Interaction"],
    ["ImmediateTransfer", "Immediate Transfer"],
    ["Other", "Miscellaneous Calls"],
    ["Transfers", "Transfers"],
    ["AiIssue", "AI Issue"],
    ["UnsupportedCustomerRequest", "Unsupported Customer Request"],
    ["CustomerFrustration", "Customer Frustration"],
    ["CustomerDelight", "Customer Delight"],
];

const FOOD_ORDERING_METRICS_TO_EXCLUDE: [string, string][] = [
    ["ActionCompletedRate", "Order Placed Rate"],
    ["ActionCompleted", "Order Placed"],
    ["UpsellSuccessfulRate", "Upsell Successful Rate"],
    ["ActionAttempted", "Order Attempted"],
    ["UPSELL_ATTEMPTED", "Attempted Upsells"],
    ["UPSELL_SUCCESSFUl", "Successful Upsells"]
]

const HEALTHCARE_METRICS_TO_EXCLUDE: [string, string][] = [
    ["ActionCompletedRate", "Appointment Modification Success Rate"],
    ["ActionCompleted", "Appointment Successfully Booked"],
    ["APPOINTMENT_RESCHEDULED", "Appointment Successfully Rescheduled"],
    ["APPOINTMENT_CANCELLED", "Appointment Successfully Cancelled"],
    ["SCHEDULE_ATTEMPTED", "Appointment Booking Attempted"],
    ["RESCHEDULE_ATTEMPTED", "Appointment Reschedule Attempted"],
    ["CANCELLATION_ATTEMPTED", "Appointment Cancellation Attempted"],
    ["SPANISH", "Spanish Calls"],
    ["UNSUPPORTED_APPOINTMENT_TYPE", "Unsupported Appointment Type Requests"],
    ["CHECK_NEXT_APPOINTMENT", "Requests For Checking New Appointments"],
    ["NEW_PATIENT", "Number of New Patient Calls"]
]

const GENERIC_METRICS_TO_EXCLUDE: [string, string][] = [
    ["ActionCompletedRate", "Action Completed Rate"],
    ["ActionAttempted", "Action Attempted"],
    ["ActionCompleted", "Action Completed"]
]

export const METRICS_TO_EXCLUDE: (featureFlagId: string) => [string, string][] = (featureFlagId: string) => {
    let metrics = UNIVERSAL_METRICS_TO_EXCLUDE
    if (featureFlagId === FoodOrderingFeatureFlagId) {
        metrics = metrics.concat(FOOD_ORDERING_METRICS_TO_EXCLUDE)
        return metrics
    }
    else if (featureFlagId === HealthcareSchedulingFeatureFlagId) {
        metrics = metrics.concat(HEALTHCARE_METRICS_TO_EXCLUDE)
        return metrics
    }
    else {
        metrics = metrics.concat(GENERIC_METRICS_TO_EXCLUDE)
        return metrics
    }
}